"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueContainer = exports.IndicatorSeparator = void 0;
var react_1 = __importStar(require("react"));
var react_select_1 = __importStar(require("react-select"));
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("./styles");
var react_jss_1 = require("react-jss");
var InputLabel_1 = require("../Input/InputLabel");
var Option_1 = require("./Option");
var __1 = require("..");
var drop_svg_1 = __importDefault(require("./assets/drop.svg"));
var MultiValueList_1 = require("./MultiValueList");
var useStyles = (0, react_jss_1.createUseStyles)(function (_a) {
    var colors = _a.colors;
    return ({
        valueCount: {
            backgroundColor: colors.Green[600],
            color: colors.Grey[0],
            width: 28,
            height: 22,
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            borderRadius: 50,
            flexShrink: 0,
        },
        valueContainer: {
            display: 'flex',
            flexWrap: 'nowrap',
            position: 'relative',
        },
        multiValueLabel: {
            backgroundColor: 'red',
        },
        root: {},
        dropIcon: {
            marginRight: 11,
            width: 12,
            height: 12,
        },
    });
});
var IndicatorSeparator = function () {
    return react_1.default.createElement("span", null);
};
exports.IndicatorSeparator = IndicatorSeparator;
var ValueContainer = function (props) {
    var children = props.children, selectProps = props.selectProps, getValue = props.getValue, className = props.className;
    var menuIsOpen = selectProps.menuIsOpen;
    var styles = useStyles();
    var value = getValue();
    var count = (0, react_1.useMemo)(function () {
        return value.length;
    }, [value, menuIsOpen]);
    return (react_1.default.createElement(react_select_1.components.ValueContainer, __assign({}, props, { getValue: getValue, selectProps: selectProps, className: (0, classnames_1.default)(className, styles.valueContainer) }),
        children,
        !!count && (react_1.default.createElement("div", { className: styles.valueCount },
            react_1.default.createElement(__1.Typography, { component: "div", variant: "textSmall" }, count)))));
};
exports.ValueContainer = ValueContainer;
var DropdownIndicator = function () {
    var styles = useStyles();
    return react_1.default.createElement("img", { src: drop_svg_1.default, className: styles.dropIcon, alt: "drop icon" });
};
var Select = function (props) {
    var onChange = props.onChange, value = props.value, label = props.label, required = props.required, className = props.className, alwaysShowCounter = props.alwaysShowCounter, placeholder = props.placeholder, rest = __rest(props, ["onChange", "value", "label", "required", "className", "alwaysShowCounter", "placeholder"]);
    var _a = (0, react_1.useState)(value), localValue = _a[0], setLocalValue = _a[1];
    (0, react_1.useEffect)(function () {
        setLocalValue(value);
    }, [value]);
    var ValueContainer = (0, react_1.useMemo)(function () { return function (props) {
        return react_1.default.createElement(MultiValueList_1.MultiValueList, __assign({}, props, { alwaysShowCounter: alwaysShowCounter }));
    }; }, [alwaysShowCounter]);
    return (react_1.default.createElement("div", { className: className },
        label && react_1.default.createElement(InputLabel_1.InputLabel, { required: required }, label),
        react_1.default.createElement(react_select_1.default, __assign({ value: localValue, theme: function (theme) { return (__assign(__assign(__assign({}, theme), { colors: __assign({}, theme.colors) }), styles_1.selectThemeStyles)); }, components: props.isMulti
                ? {
                    IndicatorSeparator: exports.IndicatorSeparator,
                    DropdownIndicator: DropdownIndicator,
                    Option: Option_1.Option,
                    ValueContainer: ValueContainer,
                }
                : { IndicatorSeparator: exports.IndicatorSeparator, DropdownIndicator: DropdownIndicator }, closeMenuOnSelect: !props.isMulti, controlShouldRenderValue: !props.isMulti, hideSelectedOptions: !props.isMulti, onChange: function (value, action) {
                setLocalValue(value);
                onChange && onChange(value, action);
            }, isClearable: false, styles: styles_1.customStyles, placeholder: placeholder }, rest))));
};
exports.default = Select;
//# sourceMappingURL=index.js.map